import React from 'react';
import PropTypes from 'prop-types';
import {Col} from 'react-bootstrap';
import {Field} from 'redux-form';
import * as fields from './fields';
import * as validators from '../../utils/validators';

const SubscriptionUserFields = ({prefix, hideEmail}) => (
  <React.Fragment>
    <Col md={hideEmail ? 12 : 6}>
      <Field
        name={`${prefix}.username`}
        label="Username"
        component={fields.Input}
        required
        validate={[validators.isRequired, validators.isUsername]}
      />
    </Col>
    {!hideEmail && (
      <Col md={6}>
        <Field
          name={`${prefix}.email`}
          label="E-mail Address"
          component={fields.Input}
          validate={[validators.isEmail]}
        />
      </Col>
    )}
    <Col md={6}>
      <Field
        name={`${prefix}.firstName`}
        label="First Name"
        component={fields.Input}
        required
        validate={[validators.isRequired]}
      />
    </Col>
    <Col md={6}>
      <Field
        name={`${prefix}.lastName`}
        label="Last Name"
        component={fields.Input}
        required
        validate={[validators.isRequired]}
      />
    </Col>
    <Col md={6}>
      <Field
        name={`${prefix}.password`}
        label="Password"
        component={fields.Input}
        required
        type="password"
        validate={[validators.isRequired]}
      />
    </Col>
    <Col md={6}>
      <Field
        name={`${prefix}.confirmPassword`}
        label="Confirm Password"
        component={fields.Input}
        required
        type="password"
        validate={[validators.isRequired, validators.isConfirmPasswordMatch]}
      />
    </Col>
  </React.Fragment>
);

SubscriptionUserFields.propTypes = {
  prefix: PropTypes.string.isRequired,
  hideEmail: PropTypes.bool.isRequired,
};

SubscriptionUserFields.defaultProps = {
  prefix: 'user',
  hideEmail: false,
};

export default SubscriptionUserFields;
